import { procurementAPI } from "../../axios";

export const actions = {
    GenerateRfq(context, data){
        return procurementAPI.put(`PublicBidding/Generate`, data);
    },
    GetSubmitted(context, data){
        return procurementAPI.get(`PublicBidding/Submitted/${data.campusId}/${data.cycle}`);
    },
    GetPosted(context, data){
        return procurementAPI.get(`PublicBidding/Posted/${data.campusId}/${data.cycle}`);
    },
    UpdatePB(context, data){
        return procurementAPI.put(`PublicBidding/Update/${data.id}`, data);
    }
}